import Facebook from '@assets/icons/facebook.svg'
import { Icon } from './Icon'

export const FacebookIcon = Icon(Facebook)
